const MASK64 = (1n << 64n) - 1n;
export const FNV_OFFSET_BASIS = 14695981039346656037n;
export const FNV_PRIME = 1099511628211n;

/** FNV-1a 64-bit hasher with the same canonical little-endian writer as the C# reference. */
export class Fnv1a64 {
  private hash = FNV_OFFSET_BASIS;

  get value(): bigint { return this.hash; }
  get hex(): string { return this.hash.toString(16).padStart(16, "0"); }

  writeByte(b: number): void {
    this.hash = ((this.hash ^ BigInt(b & 0xff)) * FNV_PRIME) & MASK64;
  }

  private writeBits(value: bigint, bytes: number): void {
    for (let i = 0; i < bytes; i++) {
      this.writeByte(Number((value >> BigInt(8 * i)) & 0xffn));
    }
  }

  writeInt(value: number): void { this.writeBits(BigInt(value >>> 0), 4); }
  writeLong(value: bigint): void { this.writeBits(value & MASK64, 8); }
  writeBool(value: boolean): void { this.writeByte(value ? 1 : 0); }
  writeRaw(raw: bigint): void { this.writeLong(raw); }

  writeString(s: string): void {
    this.writeInt(s.length);
    for (let i = 0; i < s.length; i++) this.writeBits(BigInt(s.charCodeAt(i)), 2);
  }

  static hashBytes(bytes: Uint8Array): bigint {
    const h = new Fnv1a64();
    for (const b of bytes) h.writeByte(b);
    return h.value;
  }
}
